import { NO_RANGE_INDICATOR } from '@/components/content/ProductDetails/constants';
import { ColorClassification, LineRangeColor, ProductBaseColor } from '@/data/types/ColorType';
import { getBaseColorDataByProduct } from '@/utils/colorAndPriceUtils';
import { NOT_APLICABLE_BASE } from 'shared/custom/constants/commonConstants';

export type OrderItemInput = {
	partNumber: string;
	quantity: string;
	manufacturer?: string;
	attributes?: any;
	contractId?: string;
};

/**
 * Determines the final color code for a given product item.
 * It prioritizes the globally selected color from the color drawer for the main paint product.
 * For other products, it calculates a default base color if applicable.
 */
export const getFinalColorCode = (
	item: OrderItemInput,
	colorClassification: ColorClassification | null,
	lineRangeColors: LineRangeColor[] | null,
	partNumber?: string,
	colorCode?: string,
	baseValue?: string
): string | null => {
	const isMainPaintProduct = partNumber === item.partNumber;
	if (isMainPaintProduct && colorCode) {
		if (colorCode === NOT_APLICABLE_BASE) return baseValue ?? colorCode;
		return colorCode;
	}

	const productBaseColorInfo: ProductBaseColor = getBaseColorDataByProduct(colorClassification, {
		manufacturer: item.manufacturer ?? '',
		attributes: item?.attributes,
	});

	if (productBaseColorInfo && lineRangeColors) {
		const { brandColor, lineColor, baseColor } = productBaseColorInfo;
		const colorBase = lineRangeColors.find(
			(db) => db?.brand === brandColor && db?.line === lineColor && db.range === NO_RANGE_INDICATOR
		);
		const baseRangeColorDefault = colorBase?.colors.find((color) => color?.base === baseColor);
		return baseRangeColorDefault?.value ?? null;
	}

	return null;
};

/**
 * Verify if the element is an Array and returns it, or returns it inside of an Array
 */
export const returnArray = (element: any) => {
	if (!element) return [];
	return Array.isArray(element) ? element : [element];
};
